export const DRAG_TYPES = {
  PROGRAM: 'PROGRAM',
  RESIZE_LEFT: 'RESIZE_LEFT',
  RESIZE_RIGHT: 'RESIZE_RIGHT',
  DRAGGABLE_ITEM: 'DRAGGABLE_ITEM',
};

